// extracted by mini-css-extract-plugin
export default {"wrapper":"TableDropdown_wrapper__Jlgdw","icon":"TableDropdown_icon__KhQxh","dropdown":"TableDropdown_dropdown__gPvJV","dropdownTitle":"TableDropdown_dropdownTitle__1fXt0"};